module.exports = __webpack_public_path__ + "static/avatar_brian-a92bd11ec73cd87618d2f03ec1a79be3.png";